import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { db } from "../Firebase";
import {
  doc,
  getDoc,
  collection,
  getDocs
} from "firebase/firestore";
import "../styles/UploadCertificate.css";

const UploadCertificate = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const [course, setCourse] = useState(null);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ================= FETCH COURSE + PURCHASED STUDENTS ================= */
  useEffect(() => {
    const fetchData = async () => {
      try {
        /* COURSE DATA */
        const courseSnap = await getDoc(
          doc(db, "courses", courseId)
        );

        if (!courseSnap.exists()) {
          navigate("/teacherCourse");
          return;
        }

        setCourse({
          id: courseSnap.id,
          ...courseSnap.data()
        });

        /* STUDENTS WHO BOUGHT THIS COURSE */
        const orderSnap = await getDocs(
          collection(db, "orders")
        );

        const enrolled = orderSnap.docs
          .map(d => d.data())
          .filter(o => o.courseId === courseId);

        setStudents(enrolled);

      } catch (err) {
        console.error(err);
        navigate("/teacherCourse");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [courseId, navigate]);

  if (loading) {
    return <p style={{ padding: 40 }}>Loading...</p>;
  }

  return (
    <div className="certificate-page">

      {/* ================= COURSE INFO ================= */}
      <section className="section">
        <h2>Course Information</h2>

        <div className="course-box">
          <img
            src={course.thumbnail}
            alt={course.title}
          />
          <div>
            <h3>{course.title}</h3>
            <p>{course.description}</p>
            <p><b>Price:</b> ₹{course.price}</p>
          </div>
        </div>
      </section>

      {/* ================= CERTIFICATE FORM ================= */}
      <section className="section">
        <h2>Upload Certificate Template</h2>

        <form className="certificate-form">
          <label>Certificate Title</label>
          <input
            type="text"
            placeholder="e.g. Certificate of Completion"
          />

          <label>Instructor Name</label>
          <input
            type="text"
            placeholder="Your name"
          />

          <label>Upload Certificate File (PDF / Image)</label>
          <input
            type="file"
            accept=".pdf,image/*"
          />

          <button type="button">
            Save Certificate Template
          </button>
        </form>
      </section>

      {/* ================= STUDENT LIST ================= */}
      <section className="section">
        <h2>Enrolled Students</h2>

        {students.length === 0 && (
          <p>No students enrolled yet.</p>
        )}

        {students.map((s, index) => (
          <div key={index} className="student-row">
            <span>{index + 1}. Student ID: {s.userId}</span>
            <span>Paid: ₹{s.amount}</span>
          </div>
        ))}
      </section>

      {/* ================= ACTION ================= */}
      <button
        className="back-btn"
        onClick={() => navigate("/teacherCourse")}
      >
        ← Back to My Courses
      </button>
    </div>
  );
};

export default UploadCertificate;
